/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceVisibilityTrendResponse {
    getFixupPrototypeFunction() { return ComplianceVisibilityTrendResponse.fixupPrototype; }

    static newInstance(model: Partial<ComplianceVisibilityTrendResponse>): ComplianceVisibilityTrendResponse {
        let obj = Object.assign(new ComplianceVisibilityTrendResponse(), model);
        ComplianceVisibilityTrendResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceVisibilityTrendResponse>): ComplianceVisibilityTrendResponse {
        if (!model) return null;
        return ComplianceVisibilityTrendResponse.newInstance(<ComplianceVisibilityTrendResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceVisibilityTrendResponse) {
        if (!obj) return;

        models.ComplianceVisibilityTrendResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceVisibilityTrendResponse): boolean {
        Object.setPrototypeOf(obj, ComplianceVisibilityTrendResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * success
     */
    status: string;

    /**
     * Compliance Standard Trend
     */
    message: string;

    /**
     * data for compliance visibility trend
     */
    data: any;

}
